// nav-mobile.js — ouvre la navigation principale sous 900px.
//
// .nb-nav est masquee en mobile par night-bureau.css sans substitut : Salles,
// Artistes et Guides n'etaient atteignables qu'en repassant par la recherche.
// Ce module ne fait qu'ouvrir et fermer le panneau ; la mise en page est en CSS
// (.nb-head.nav-open .nb-nav), pour que rien ne bouge si le JS ne charge pas —
// dans ce cas le bouton reste inerte et la nav reste masquee, comme avant.
(function () {
  'use strict';

  const head = document.querySelector('.nb-head');
  const btn = document.getElementById('nb-burger');
  const nav = document.getElementById('nb-nav');
  if (!head || !btn || !nav) return;

  function setOpen(open) {
    head.classList.toggle('nav-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  }

  btn.addEventListener('click', (ev) => {
    ev.stopPropagation();
    setOpen(!head.classList.contains('nav-open'));
  });

  // Naviguer ferme le panneau (utile quand le lien pointe vers la page courante).
  nav.addEventListener('click', (ev) => {
    if (ev.target.closest('a')) setOpen(false);
  });

  document.addEventListener('click', (ev) => {
    if (!head.classList.contains('nav-open')) return;
    if (!ev.target.closest('.nb-head')) setOpen(false);
  });

  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && head.classList.contains('nav-open')) {
      setOpen(false);
      btn.focus();
    }
  });

  // Repasser en desktop doit remettre l'etat a plat : la nav y est toujours
  // visible, et .nav-open y deviendrait un residu invisible mais actif.
  window.addEventListener('resize', () => {
    if (window.innerWidth > 900 && head.classList.contains('nav-open')) setOpen(false);
  });
})();
